import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
          <p className="text-dark-400 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">Our Commitment to Your Privacy</h2>
              <p className="text-dark-300 leading-relaxed">
                At GINGERBREAD!PRIVACY (operated by Monadnock Cyber LLC), we understand the sensitive nature of privacy intelligence services.
                Your personal information is handled with the utmost care and security. This policy explains how we collect, use,
                and protect your data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Data Collection</h2>
              <p className="text-dark-300 leading-relaxed mb-4">We collect only the information necessary to provide our services:</p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li><strong>Account Information:</strong> Email address and encrypted password for authentication</li>
                <li><strong>Assessment Data:</strong> Names, email addresses, phone numbers, and addresses you provide for privacy assessments</li>
                <li><strong>Payment Information:</strong> Processed securely through Stripe; we do not store your payment card details</li>
                <li><strong>Usage Data:</strong> Basic analytics to improve our services</li>
              </ul>
            </section>

            <section className="bg-ginger-500/10 border border-ginger-500/30 rounded-lg p-6">
              <h2 className="text-2xl font-bold mb-4 text-ginger-500">Data Deletion Policy</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                <strong>We take data minimization seriously.</strong> After your privacy assessment report is delivered:
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>All personal identifying information (PII) submitted for assessment is <strong>permanently deleted within 30 days</strong> of report delivery</li>
                <li>Your encrypted PDF report remains available in your account for 90 days, then is automatically deleted</li>
                <li>You may request immediate deletion of your data at any time by contacting us</li>
                <li>Account credentials are retained only while your account is active</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">How We Use Your Data</h2>
              <p className="text-dark-300 leading-relaxed mb-4">Your data is used exclusively to:</p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Conduct privacy risk assessments and generate your reports</li>
                <li>Authenticate your account and maintain security</li>
                <li>Process payments for our services</li>
                <li>Send important service-related communications</li>
                <li>Improve our platform and services</li>
              </ul>
              <p className="text-dark-300 leading-relaxed mt-4">
                <strong>We never sell your personal information.</strong> We do not share your data with third parties
                except as necessary to provide our services (e.g., payment processing through Stripe).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Data Security</h2>
              <p className="text-dark-300 leading-relaxed mb-4">We implement industry-standard security measures:</p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>All data is encrypted in transit using TLS 1.3</li>
                <li>Passwords are hashed using Argon2 (industry-leading algorithm)</li>
                <li>Two-factor authentication (2FA) is mandatory for all accounts</li>
                <li>Regular security audits and vulnerability assessments</li>
                <li>Access to customer data is strictly limited and logged</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Privacy Law Compliance</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                We comply with applicable privacy laws and regulations, including:
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li><strong>CCPA (California Consumer Privacy Act):</strong> California residents have the right to know what data we collect, request deletion, and opt out of data sales (we do not sell data)</li>
                <li><strong>GDPR (General Data Protection Regulation):</strong> EU residents have rights to access, rectification, erasure, and data portability</li>
                <li><strong>State Privacy Laws:</strong> We comply with privacy regulations in Virginia, Colorado, Connecticut, Utah, and other states with applicable laws</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Your Rights</h2>
              <p className="text-dark-300 leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your data in a portable format</li>
                <li>Withdraw consent at any time</li>
                <li>Lodge a complaint with a supervisory authority</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Cookies</h2>
              <p className="text-dark-300 leading-relaxed">
                We use essential cookies only for authentication and session management. We do not use tracking cookies
                or third-party advertising cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Changes to This Policy</h2>
              <p className="text-dark-300 leading-relaxed">
                We may update this policy from time to time. We will notify you of any material changes by email
                or through a prominent notice on our website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
              <p className="text-dark-300 leading-relaxed">
                For privacy-related inquiries or to exercise your rights, contact us at:
              </p>
              <div className="mt-4 text-dark-300">
                <p><strong>Monadnock Cyber LLC</strong></p>
                <p>Email: <a href="mailto:privacy@monadnockcyber.com" className="text-ginger-500 hover:underline">privacy@monadnockcyber.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
